import { CheckIcon, DocumentDuplicateIcon } from "@heroicons/react/outline";
import { CopyToClipboard } from "react-copy-to-clipboard";

import CodeEditor from "../../CodeEditor";
import { LanguageNameMap, languages } from "../../CodeEditor/constants";

import { ApiKeyResultStepContentProps } from "./types";

import { Input } from "@/components/ui/input";

export const ApiKeyResultStepContent = ({
  activeWorkspaceName,
  apiKey,
  isCopied,
  language,
  onCopyKey,
  onLanguageChange,
  codeBlock,
}: ApiKeyResultStepContentProps) => (
  <div className="overflow-x-auto">
    <div className="grid grid-cols-5 items-baseline py-3">
      <div className="col-span-1 py-2 text-sm font-light text-gray-800">WORKSPACE:</div>
      <div className="col-span-4 text-sm font-semibold text-gray-800">{activeWorkspaceName}</div>
      <div className="col-span-1 py-2 text-sm font-light text-gray-800">API KEY:</div>
      <div className="col-span-4">
        <div className="flex">
          <Input
            value={apiKey ?? ""}
            readOnly
            className="text-gray-600 hover:text-gray-700 focus:text-gray-800"
          />
          <span className="ml-2 cursor-pointer rounded-md border hover:bg-gray-50">
            <CopyToClipboard text={apiKey ?? ""} onCopy={onCopyKey}>
              <span className="cursor-pointer">
                {isCopied ? (
                  <CheckIcon className="mt-2 h-5 w-auto flex-shrink-0 px-2 text-gray-500 hover:text-gray-700" />
                ) : (
                  <DocumentDuplicateIcon className="mt-2 h-5 w-auto flex-shrink-0 px-2 text-gray-500 hover:text-gray-700" />
                )}
              </span>
            </CopyToClipboard>
          </span>
        </div>
      </div>
    </div>
    <div className="overflow-x-auto px-1">
      <h4 className="my-2 text-sm font-light leading-6 text-gray-800">
        Setting up your API key in {LanguageNameMap[language]}
      </h4>
      <CodeEditor
        code={codeBlock}
        docsLink="https://docs.promptlayer.com"
        showRuntimeDetails={false}
        height="80px"
        handleLanguageChange={onLanguageChange}
        selectedLanguage={language}
        languages={languages}
        showFullScreenButton={false}
        editorOptions={{
          readOnly: true,
        }}
      />
    </div>
  </div>
);
